<template>
  <btn-primary
    :loading="loading"
    icon="mdi-update"
    text="Atualizar"
    :disabled="isDisabled"
    @click="update()"
  />
</template>

<script>
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';

export default {
  name: 'ReportListUpdateButton',
  components: { BtnPrimary },
  data: () => ({
    loading: '',
    listName: 'ReportList',
    totalItems: 0,
  }),
  computed: {
    isDisabled() {
      return this.totalItems === 0;
    },
  },
  created() {
    this.handleLoading();
    this.handleTotalItems();
  },
  methods: {
    update() {
      this.$root.$emit(`refresh-crud-${this.listName}`, true);
    },
    handleLoading() {
      this.$root.$on(`loading-crud-${this.listName}`, (bool) => {
        if (typeof bool === 'boolean') this.loading = bool;
      });
    },
    handleTotalItems() {
      this.$root.$on(`total-itens-${this.listName}`, (total) => {
        this.totalItems = total;
      });
    },
  },
};
</script>
